export enum LocalStorageKeys {
  SETTING = "EVR_Setting",
  TOKEN = "EVR_AuthToken",
  IS_FIRST_LOGIN = "EVR_FIRST_LOGIN",
  SSO_URL = "ssoURL",
  IS_FIRST_VERIZON_IMPORT = "EVR_FIRST_VERIZON_IMPORT",
  CURRENCIES = "currencies",
}
